import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TRunSSNVerificationRequestSchema,
  TRunSSNVerificationResponseSchema,
} from "./runSSNVerification.schema";

export const runSSNVerification = (axios: IAxiosInstance) => {
  return async (body: TRunSSNVerificationRequestSchema) => {
    const response =
      await axios.noRetry.post<TRunSSNVerificationResponseSchema>(
        "/api/ssn-verification",
        body
      );

    return response.data;
  };
};
